import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation, useMatch } from 'react-router-dom';

import { cn } from '@/shared/lib/utils';

import type { FooterTab as FooterTabConfig } from './footer.config';

interface FooterTabProps {
  tab: FooterTabConfig;
  onClick: (tabId: string, isAlreadyActive: boolean) => void;
}

export const FooterTab = memo(function FooterTab({ tab, onClick }: FooterTabProps) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const exactMatch = Boolean(useMatch(tab.id));
  const isActive = exactMatch || Boolean(tab.matchPaths?.some((p) => pathname === p));

  const handleClick = () => {
    onClick(tab.id, isActive);
  };

  return (
    <NavLink
      to={tab.id}
      onClick={handleClick}
      className={cn('footer__link', {
        'footer__link--active': isActive,
        'footer__link--disabled': tab.disabled,
      })}>
      {(() => {
        const TabIcon = isActive ? tab.iconActive : tab.iconInactive;
        return <TabIcon className="footer__icon" />;
      })()}
      <span className="footer__label">{t(tab.label)}</span>
    </NavLink>
  );
});
